(function($){
    $(function(){

        var $window = $(window),
            $body = $('body');

        var $nav = $('.nav'),
            $navContent = $('.nav-content'),
            $navOpen = $('.nav-open'),
            $navClose = $('.nav-close'),
            $navToggle = $('.nav-toggle'),
            navOpened = 'nav-opened';

        var adjustNavMaxHeight = function(){
            var contentHeight = $navContent.children().height(),
                wHeight = $window.height(),
                buttonHeight = $navToggle.height();

            var css = {};

            if ( ( contentHeight + buttonHeight ) > wHeight){
                css['overflowY'] = 'scroll';
            } else {
                css['overflowY'] = 'auto';
            }

            css['maxHeight'] = wHeight - buttonHeight;

            $navContent.css(css);
        };

        adjustNavMaxHeight();
        $window.on('resize', adjustNavMaxHeight);

        var openNav = function(){
            $navContent.animate({
                height: $navContent.children().height()
            }, function(){
               $nav.addClass(navOpened);
            });
        };

        var closeNav = function(){
            $navContent.animate({
                height: 0
            }, function(){
                $nav.removeClass(navOpened);
            });
        };

        $navOpen.on('click', function(e){
            e.preventDefault();
            openNav();
        });

        $navClose.on('click', function(e){
            e.preventDefault();
            closeNav();
        });


        var $emblem = $('.emblem'),
            $contentDown = $('.content-down'),
            contentBottomOffset = 138;

        var adjustEmblemHeight = function(){

            var wHeight = $window.height(),
                cHeight = $contentDown.outerHeight(true);

            var eHeight = $emblem.data('height');
            if (!eHeight){
                eHeight = $emblem.height();
                $emblem.data('height', eHeight);
            }

            var viewArea = eHeight + cHeight + contentBottomOffset;

            var tmpHeight = wHeight - eHeight - cHeight - contentBottomOffset;

            if (viewArea > wHeight){
                var needed = wHeight - cHeight - contentBottomOffset;

                if (needed < 302){
                    needed = 302;
                }

                var iHeight = 406;

                var scale = needed / $emblem.data('height');

                $emblem.css({
                    height: needed,
                    backgroundSize: ( scale * iHeight ).toFixed(0) + 'px'
                });
            } else {
                $emblem.css({
                    'height': eHeight,
                    backgroundSize: 'auto'
                });
            }
        };

//        adjustEmblemHeight();
//        $window.on('resize', adjustEmblemHeight);

        $contentDown.on('click', function(e){
            e.preventDefault();

            var $target = $( $(this).data('target') );
            if ($target.length){
                $('html, body').animate({
                    scrollTop: $target.position().top
                });
            }
        });


        $('.gallery-icon a').fancybox();
        $('a.gallery-item').on('click', function(e){
            e.preventDefault();
            $.fancybox.open($(this).data('images'));
        });

        var $contact = $('.contact'),
            $contactForm = $('.contact-form'),
            $contactSuccess = $('.contact-success'),
            contactLocked = false,
            contactErrors = {};

        $contact.find('[data-for]').each(function(index, el){
            var $el = $(el);
            contactErrors[$el.data('for')] = $el;
        });

        $contact.on('submit', function(e)
        {
            e.preventDefault();

            if (contactLocked){
                return;
            }

            contactLocked = true;
            var $el = $(this);

            for (var i in contactErrors){
                contactErrors[i].empty();
            }

            $.post($(this).attr('action'), $el.serialize(), function(data){

                contactLocked = false;

                if (data.success){
                    $contact.css({
                        minHeight: $contactForm.height()
                    });

                    $contactSuccess.css({
                        display: 'block',
                        opacity: 0
                    });

                    $
                        .when($contactForm.fadeOut())
                        .then($contact.animate({
                            minHeight: $contactSuccess.height()
                        }))
                        .then($contactSuccess.animate({
                            opacity: 1,
                            display: 'block'
                        }));

                    $contact.find('success').html();
                } else if (data.errors) {
                    for (var i in data.errors){
                        if ( !contactErrors[i] ) {
                            continue;
                        }
                        contactErrors[i].text(data.errors[i]);
                    }
                }
            });
        });

    });
}(jQuery));
